import React from 'react'
import { Input as TextInput } from '@progress/kendo-react-inputs';

const Input = (props) => {


    return (
        <TextInput {...props} />
    )
}

export default Input;


// WEBPACK FOOTER //
// ./src/components/Input/index.js